import { render } from "./homeComponent.vue?vue&type=template&id=70583737&scoped=true"
import script from "./homeComponent.vue?vue&type=script&lang=js"
export * from "./homeComponent.vue?vue&type=script&lang=js"

import "./homeComponent.vue?vue&type=style&index=0&id=70583737&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70583737"]])

export default __exports__